import type {commonState, commonAction} from './types'

const INITIAL_STATE: commonState = {
  query: {} as any,
}

export const commonReducer = (
  prev: commonState = INITIAL_STATE,
  action: commonAction
): commonState => {
  switch (action.type) {
    case 'COMMON/SET_QUERY':
      return {
        ...prev,
        query: action.payload,
      }

    default:
      return prev
  }
}
